import tripEvents from '../../config/events.constant';
import carbonPurchase from '../../carbon-purchase-options';

export default function TripCheckoutCarbonController(
    $scope,
    $rootScope,
    tripData,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
       $onInit,
    });

    function $onInit() {
        const isCarbonMandatory = tripData.CarbonPurchase === carbonPurchase.Mandatory;

        $scope.purchaseCarbon = tripData.IsCarbonPurchased;
        $scope.isDisabled = isCarbonMandatory || tripData.IsApproved;
        $scope.pricePerTone = tripData.CarbonPerTonnePrice;
        $scope.price = tripData.Prices.CarbonPrice.Amount;
    }

    $scope.onCarbonChange = function() {
        $rootScope.$broadcast(tripEvents.TRIP_UPDATE_COSTS, {purchaseCarbon: $scope.purchaseCarbon});
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/checkout/trip-checkout-carbon-controller.js